import { ComponentType } from 'react';
import { EXTERNAL_SALES_BASE_PATH } from './config';
import { ExternalSalesModule } from './ExternalSalesModule';

export type ExternalSalesRoute = {
  path: string;
  component: ComponentType;
};

export const externalSalesRoutes: ExternalSalesRoute[] = [
  { path: EXTERNAL_SALES_BASE_PATH, component: ExternalSalesModule },
];
